import { convertProductToAnalyticsEcommerceItem } from './analyticsProduct';
import {
  EcommerceAddToCartDataLayerEvent,
  EcommerceEvent,
  EcommerceRemoveFromCartDataLayerEvent,
  pushGTMEcommerceEvent,
} from '@helpers/analyticsHelpers/pushGTMEvent';
import type { AxfoodCartProductViewModel } from '@occ/api-client';

const trackCartModification = (
  value: number,
  previousQuantity: number,
  product: AxfoodCartProductViewModel,
  list: string | null,
  cartCode: string,
  newCart: boolean,
  isLoggedIn?: boolean
) => {
  const remove = previousQuantity > value;
  const parsedValue = +parseFloat(String(value)).toFixed(1);
  const rawDelta = remove
    ? previousQuantity - parsedValue
    : previousQuantity
      ? parsedValue - previousQuantity
      : parsedValue;

  // For KG-basket products, value/previousQuantity are in kg (e.g. 0.1, 0.2).
  // Convert the fractional delta to integer increment-unit count (minimum 1).
  const incrementValue = product.incrementValue || 1;
  const quantity = incrementValue < 1 && rawDelta > 0 ? Math.max(1, Math.round(rawDelta / incrementValue)) : rawDelta;
  const isPromotionPage =
    list === 'personal-campaigns-online' ||
    list === 'personal-campaigns-offline' ||
    list === 'generic-campaigns-online' ||
    list === 'generic-campaigns-offline';

  const listArr = isPromotionPage ? list.split('-') : [];
  const listName = isPromotionPage
    ? `promotion_page | ${listArr[2] === 'online' ? 'ecommerce' : 'store'} | ${listArr[0]}`
    : list;

  pushGTMEcommerceEvent({
    event: remove ? EcommerceEvent.REMOVE_FROM_CART : EcommerceEvent.ADD_TO_CART,
    ecommerce: {
      cart_id: cartCode,
      ...(remove ? {} : { new_cart: newCart }),
      items: [convertProductToAnalyticsEcommerceItem(product, quantity, listName || undefined, isLoggedIn)],
    },
  } as EcommerceRemoveFromCartDataLayerEvent | EcommerceAddToCartDataLayerEvent);
};

export default trackCartModification;
